
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatbotConfig } from '@shared/index';
import { BotLoginService } from '../../shared/services/bot-login.service';
import { LanguageService } from '@shared-angular/services/language.service';

type JoinQueryParam = {
  accesstoken: string,
  target?: 'audio' | 'avatar'
}

type InstantAccessParam = {
  id: string,
  guestid: string,
  metadata: string,
  bottype: JoinQueryParam['target']
}

@Component({
  selector: 'app-instant-access',
  imports: [],
  templateUrl: './instant-access.component.html',
  styleUrl: './instant-access.component.scss'
})
export class InstantAccessComponent {
  public botConfig!: ChatbotConfig;
  public isAllowed = true;

  constructor(
    public route: ActivatedRoute,
    public botLoginService: BotLoginService,
    public languageService: LanguageService,
    public router: Router
  ) {
    route.params.subscribe(async params => {
      const { id, guestid, metadata, bottype } = params as InstantAccessParam;
      try {
        const instantAccess = await botLoginService.instantAccessBot(id, guestid, metadata);
        const queryParams: JoinQueryParam = { accesstoken: instantAccess.createdUser.accessToken };
        if (params['bottype'] !== 'chat') queryParams.target = bottype;
        await router.navigate(["/botaccess"], { queryParams });
      } catch (e) {
        this.isAllowed = false;
        console.error(e);
      }
    });

  }
}